import { SvgIconComponent } from '../types/svgs';

const ActivityAudio: SvgIconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.25 6.25C13.25 3.3505 10.8995 1 8 1C5.1005 1 2.75 3.3505 2.75 6.25M11 8.875V10.375C11 10.7235 11 10.8977 11.0288 11.0426C11.1472 11.6377 11.612 12.1028 12.207 12.2212C12.3519 12.25 12.5265 12.25 12.875 12.25C13.2235 12.25 13.3977 12.25 13.5426 12.2212C14.1377 12.1028 14.6031 11.6377 14.7214 11.0426C14.7503 10.8977 14.75 10.7235 14.75 10.375V8.875C14.75 8.52651 14.7503 8.3523 14.7214 8.2074C14.6031 7.61236 14.1377 7.14718 13.5426 7.02882C13.3977 7 13.2235 7 12.875 7C12.5265 7 12.3519 7 12.207 7.02882C11.612 7.14718 11.1472 7.61236 11.0288 8.2074C11 8.3523 11 8.52651 11 8.875ZM5 8.875V10.375C5 10.7235 5.00026 10.8977 4.97144 11.0426C4.85308 11.6377 4.38767 12.1028 3.79264 12.2212C3.64774 12.25 3.47315 12.25 3.12467 12.25C2.77618 12.25 2.60193 12.25 2.45703 12.2212C1.862 12.1028 1.39718 11.6377 1.27882 11.0426C1.25 10.8977 1.25 10.7235 1.25 10.375V8.875C1.25 8.52651 1.25 8.3523 1.27882 8.2074C1.39718 7.61236 1.862 7.14718 2.45703 7.02882C2.60193 7 2.77618 7 3.12467 7C3.47316 7 3.64774 7 3.79264 7.02882C4.38767 7.14718 4.85308 7.61236 4.97144 8.2074C5.00026 8.3523 5 8.52651 5 8.875Z"
        stroke="#394642"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ActivityAudio;
